import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { UpdateFormulaCardResponse, UpdateFormulaCardVariables } from '../types';

const updateFormulaCardMutation = gql`
  mutation OvertimeUpdateFormulaCard($id: String!, $input: UpdateOTFormulaCardInput!) {
    overtimeUpdateFormulaCard(id: $id, input: $input) {
      code
      success
      message
      data {
        formulaCard {
          id
          name
          rateType
          rateUnit
          flatRate
          multiplier
          dailyAllowance
          formulaTemplate
          status
          createdAt
          updatedAt
          createdBy
        }
      }
    }
  }
`;

const updateFormulaCard = (queryVariables: UpdateFormulaCardVariables) => {
  return graphQLApi<UpdateFormulaCardResponse, UpdateFormulaCardVariables>({
    query: updateFormulaCardMutation,
    queryVariables,
  });
};

export default updateFormulaCard;
